export default [
    {
        id: "alberto-montt",
        videoCover: require("../../../static/img/video-cover/ALBERTO_MONTT.jpg"),
        hasVideo: true,
        videoSrc: "interviews/ALBERTO_MONTT.mp4",
    },
    {
        id: "francisco-toledo",
        hasVideo: false,
        videoCover: require("../../../static/img/video-cover/FRANCISCO_TOLEDO.jpg"),
    },
    {
        id: "jose-santiago",
        videoCover: require("../../../static/img/video-cover/JOSE_ANGEL.jpg"),
        hasVideo: true,
        videoSrc: "interviews/JOSE_SANTIAGO.mp4",
    },
    {
        id: "power-paola",
        videoCover: require("../../../static/img/video-cover/POWERPAOLA.jpg"),
        hasVideo: true,
        videoSrc: "interviews/POWERPAOLA.mp4",
    },
    {
        id: "paulina-jaimes",
        videoCover: require("../../../static/img/video-cover/PAULINA_JAIMES.jpg"),
        hasVideo: true,
        videoSrc: "interviews/PAULINA_JAIMES.mp4",
    },
    {
        id: "javier-sierra",
        videoCover: require("../../../static/img/video-cover/JAVIER_SIERRA.jpg"),
        hasVideo: true,
        videoSrc: "interviews/JAVIER_SIERRA.mp4",
    },
    {
        id: "kraken",
        videoCover: require("../../../static/img/video-cover/KRAKEN.jpg"),
        hasVideo: true,
        videoSrc: "interviews/KRAKEN.mp4",
    },
    {
        id: "maria-duenas",
        videoCover: require("../../../static/img/video-cover/MARIA_DUENAS.jpg"),
        hasVideo: true,
        videoSrc: "interviews/MARIA_DUENAS.mp4",
    },
    {
        id: "luis-urrea",
        videoCover: require("../../../static/img/video-cover/LUIS_URREA.jpg"),
        hasVideo: true,
        videoSrc: "interviews/LUIS_URREA.mp4",
    },
    {
        id: "marcos-castro",
        videoCover: require("../../../static/img/video-cover/MARCOS_CASTRO.jpg"),
        hasVideo: true,
        videoSrc: "interviews/MARCOS_CASTRO.mp4",
    },
    {
        id: "manuel-monroy",
        videoCover: require("../../../static/img/video-cover/MANUEL_MONROY.jpg"),
        hasVideo: true,
        videoSrc: "interviews/MANUEL_MONROY.mp4",
    },
    {
        id: "mike-sandoval",
        videoCover: require("../../../static/img/video-cover/MIKE_SANDOVAL.jpg"),
        hasVideo: true,
        videoSrc: "interviews/MIKE_SANDOVAL.mp4",
    },
    {
        id: "ciler",
        videoCover: require("../../../static/img/video-cover/CILER.jpg"),
        hasVideo: true,
        videoSrc: "interviews/CILER.mp4",
    },
    {
        id: "trine-ellitsgaard",
        videoCover: require("../../../static/img/video-cover/TRINE_ELLITSGAARD.jpg"),
        hasVideo: false,
    },
    {
        id: "cesar-cordova",
        videoCover: require("../../../static/img/video-cover/CESAR_CORDOVA.jpg"),
        hasVideo: true,
        videoSrc: "interviews/CESAR_CORDOVA.mp4",
    },
    {
        id: "taquito",
        videoCover: require("../../../static/img/video-cover/TAQUITO.jpg"),
        hasVideo: true,
        videoSrc: "interviews/TAQUITO.mp4",
    },
    {
        id: "elena-poniatowska",
        videoCover: require("../../../static/img/video-cover/ELENA_PONIATOWSKA.jpg"),
        hasVideo: true,
        videoSrc: "interviews/ELENA_PONIATOWSKA.mp4",
    },
    {
        id: "gabriel-meave",
        videoCover: require("../../../static/img/video-cover/GABRIEL_MARTINEZ.jpg"),
        hasVideo: true,
        videoSrc: "interviews/GABRIEL_MARTINEZ.mp4",
    },
    {
        id: "malafacha",
        videoCover: require("../../../static/img/video-cover/MALAFACHA.jpg"),
        hasVideo: true,
        videoSrc: "interviews/MALAFACHA.mp4",
    },
    {
        id: "horacio-quiroz",
        videoCover: require("../../../static/img/video-cover/HORACIO_QUIROZ.jpg"),
        hasVideo: true,
        videoSrc: "interviews/HORACIO_QUIROZ.mp4",
    },
    {
        id: "sabino-guisu",
        videoCover: require("../../../static/img/video-cover/SABINO_GUISU.jpg"),
        hasVideo: true,
        videoSrc: "interviews/SABINO_GUISU.mp4",
    },
    {
        id: "jorge-tellaeche",
        videoCover: require("../../../static/img/video-cover/TALLAECHE.jpg"),
        hasVideo: true,
        videoSrc: "interviews/TALLAECHE.mp4",
    },
    {
        id: "dr-lakra",
        videoCover: require("../../../static/img/video-cover/DR_LAKRA.jpg"),
        hasVideo: false,
    },
    {
        id: "oliver-jeffers",
        videoCover: require("../../../static/img/video-cover/OLIVER_JEFFERS.jpg"),
        hasVideo: false,
    },
    {
        id: "emmanuel-garcia",
        videoCover: require("../../../static/img/video-cover/EMMANUEL_GARCIA.jpg"),
        hasVideo: true,
        videoSrc: "interviews/EMMANUEL_GARCIA.mp4",
    },
    {
        id: "mariana-magdaleno",
        videoCover: require("../../../static/img/video-cover/MARIANA_MAGDALENO.jpg"),
        hasVideo: true,
        videoSrc: "interviews/MARIANA_MAGDALENO.mp4",
    },
    {
        id: "matias-prado",
        videoCover: require("../../../static/img/video-cover/MATIAS_PRADO.jpg"),
        hasVideo: true,
        videoSrc: "interviews/MATIAS_PRADO.mp4",
    }
];



// WEBPACK FOOTER //
// ./src/assets/data/chapters.js